import { gsap, CustomEvents } from '@powerplay/common';
import { phasesConfig } from '../config';
export class PhaseManager {
    cameraManager;
    inputsManager;
    fpsManager;
    requestManager;
    phaseNumber = 0;
    finished = false;
    skippable = false;
    framesInPhase = 0;
    tweenTimeoutToNextPhase;
    TIME_TO_NEXT_PHASE = 0;
    PHASE_NAME = '';
    framesToWaitForSkipAfterPhaseStarts = phasesConfig.framesToWaitForSkipAfterPhaseStarts;
    constructor(cameraManager, inputsManager, fpsManager, requestManager) {
        this.cameraManager = cameraManager;
        this.inputsManager = inputsManager;
        this.fpsManager = fpsManager;
        this.requestManager = requestManager;
    }
    setPhaseDuration(duration) {
        this.TIME_TO_NEXT_PHASE = duration;
    }
    setPhaseNotSkippableFrames(notSkippableFrames) {
        this.framesToWaitForSkipAfterPhaseStarts = notSkippableFrames;
    }
    update() {
        this.framesInPhase++;
        if (this.skippable &&
            this.inputsManager.actionPressed &&
            this.framesInPhase > this.framesToWaitForSkipAfterPhaseStarts) {
            this.skipPhase();
        }
    }
    skipPhase() {
        console.log(`skip phase ${this.PHASE_NAME}`);
        this.finishPhase();
    }
    startPhase() {
        this.finished = false;
        this.framesInPhase = 0;
        console.log(`start phase ${this.PHASE_NAME}`);
        if (this.TIME_TO_NEXT_PHASE > 0) {
            this.tweenTimeoutToNextPhase = gsap.to({}, {
                duration: this.TIME_TO_NEXT_PHASE,
                onComplete: this.finishPhase,
                callbackScope: this
            });
        }
    }
    finishPhase() {
        if (this.finished)
            return;
        this.finished = true;
        console.log(`finish phase ${this.PHASE_NAME}`);
        if (this.tweenTimeoutToNextPhase)
            this.tweenTimeoutToNextPhase.kill();
        this.cameraManager.stopTween();
        window.dispatchEvent(new CustomEvent(CustomEvents.finishPhase));
    }
}
//# sourceMappingURL=PhaseManager.js.map